export default __webpack_public_path__ + "static/Fabian-7899103831a85088e7d3949c9a5ef3815389967459660ba7218ce9bd71f70410.svg";